'use strict';
import * as $j_app$002eprelude$002e$002dApp$002dCurrency$0024$0024anon$00242 from "./app.prelude.-App-Currency$$anon$2.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_prelude_AppCurrency$namedEnum$() {
  this.aXT = null;
  this.aXU = null;
  this.aXV = false;
  $n_Lapp_prelude_AppCurrency$namedEnum$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__$init$__V(this);
}
export { $c_Lapp_prelude_AppCurrency$namedEnum$ as $c_Lapp_prelude_AppCurrency$namedEnum$ };
$p = $c_Lapp_prelude_AppCurrency$namedEnum$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_prelude_AppCurrency$namedEnum$;
/** @constructor */
function $h_Lapp_prelude_AppCurrency$namedEnum$() {
}
export { $h_Lapp_prelude_AppCurrency$namedEnum$ as $h_Lapp_prelude_AppCurrency$namedEnum$ };
$h_Lapp_prelude_AppCurrency$namedEnum$.prototype = $p;
$p.IK = (function() {
  return this.aXT;
});
$p.VV = (function(x$0) {
  this.aXT = x$0;
});
$p.wy = (function() {
  if ((!this.aXV)) {
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().fw($m_Lapp_prelude_AppCurrency$().bZB());
    this.aXU = $x_1.E4($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().aO(this$2));
    this.aXV = true;
  }
  return this.aXU;
});
$p.yN = (function(a) {
  return a.av0().eE;
});
var $d_Lapp_prelude_AppCurrency$namedEnum$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_prelude_AppCurrency$namedEnum$, "app.prelude.AppCurrency$namedEnum$", ({
  Id: 1,
  da: 1
}));
export { $d_Lapp_prelude_AppCurrency$namedEnum$ as $d_Lapp_prelude_AppCurrency$namedEnum$ };
var $n_Lapp_prelude_AppCurrency$namedEnum$;
function $m_Lapp_prelude_AppCurrency$namedEnum$() {
  if ((!$n_Lapp_prelude_AppCurrency$namedEnum$)) {
    $n_Lapp_prelude_AppCurrency$namedEnum$ = new $c_Lapp_prelude_AppCurrency$namedEnum$();
  }
  return $n_Lapp_prelude_AppCurrency$namedEnum$;
}
export { $m_Lapp_prelude_AppCurrency$namedEnum$ as $m_Lapp_prelude_AppCurrency$namedEnum$ };
function $s_Lapp_prelude_AppCurrency$__USD__Lapp_prelude_AppCurrency() {
  $m_Lapp_prelude_AppCurrency$();
  return $t_Lapp_prelude_AppCurrency$__USD;
}
export { $s_Lapp_prelude_AppCurrency$__USD__Lapp_prelude_AppCurrency as $s_Lapp_prelude_AppCurrency$__USD__Lapp_prelude_AppCurrency };
function $s_Lapp_prelude_AppCurrency$__EUR__Lapp_prelude_AppCurrency() {
  $m_Lapp_prelude_AppCurrency$();
  return $t_Lapp_prelude_AppCurrency$__EUR;
}
export { $s_Lapp_prelude_AppCurrency$__EUR__Lapp_prelude_AppCurrency as $s_Lapp_prelude_AppCurrency$__EUR__Lapp_prelude_AppCurrency };
function $s_Lapp_prelude_AppCurrency$__GBP__Lapp_prelude_AppCurrency() {
  $m_Lapp_prelude_AppCurrency$();
  return $t_Lapp_prelude_AppCurrency$__GBP;
}
export { $s_Lapp_prelude_AppCurrency$__GBP__Lapp_prelude_AppCurrency as $s_Lapp_prelude_AppCurrency$__GBP__Lapp_prelude_AppCurrency };
function $s_Lapp_prelude_AppCurrency$__INR__Lapp_prelude_AppCurrency() {
  $m_Lapp_prelude_AppCurrency$();
  return $t_Lapp_prelude_AppCurrency$__INR;
}
export { $s_Lapp_prelude_AppCurrency$__INR__Lapp_prelude_AppCurrency as $s_Lapp_prelude_AppCurrency$__INR__Lapp_prelude_AppCurrency };
/** @constructor */
function $c_Lapp_prelude_AppCurrency$() {
  this.aXK = null;
  this.aXP = null;
  this.aXQ = false;
  this.aXN = null;
  this.aXO = false;
  this.aXL = null;
  this.aXM = false;
  this.aXR = null;
  this.aXS = false;
  $n_Lapp_prelude_AppCurrency$ = this;
  $t_Lapp_prelude_AppCurrency$__USD = new $c_Lapp_prelude_AppCurrency$$anon$1("USD", 0);
  $t_Lapp_prelude_AppCurrency$__EUR = new $c_Lapp_prelude_AppCurrency$$anon$1("EUR", 1);
  $t_Lapp_prelude_AppCurrency$__GBP = new $c_Lapp_prelude_AppCurrency$$anon$1("GBP", 2);
  $t_Lapp_prelude_AppCurrency$__INR = new $c_Lapp_prelude_AppCurrency$$anon$1("INR", 3);
  this.aXK = new ($d_Lapp_prelude_AppCurrency.r().C)([$s_Lapp_prelude_AppCurrency$__USD__Lapp_prelude_AppCurrency(), $s_Lapp_prelude_AppCurrency$__EUR__Lapp_prelude_AppCurrency(), $s_Lapp_prelude_AppCurrency$__GBP__Lapp_prelude_AppCurrency(), $s_Lapp_prelude_AppCurrency$__INR__Lapp_prelude_AppCurrency()]);
}
export { $c_Lapp_prelude_AppCurrency$ as $c_Lapp_prelude_AppCurrency$ };
$p = $c_Lapp_prelude_AppCurrency$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_prelude_AppCurrency$;
/** @constructor */
function $h_Lapp_prelude_AppCurrency$() {
}
export { $h_Lapp_prelude_AppCurrency$ as $h_Lapp_prelude_AppCurrency$ };
$h_Lapp_prelude_AppCurrency$.prototype = $p;
$p.bZB = (function() {
  return this.aXK.aS();
});
$p.bMY = (function() {
  if ((!this.aXQ)) {
    this.aXP = new $j_app$002eprelude$002e$002dApp$002dCurrency$0024$0024anon$00242.$c_Lapp_prelude_AppCurrency$$anon$2();
    this.aXQ = true;
  }
  return this.aXP;
});
$p.Au = (function() {
  if ((!this.aXO)) {
    this.aXN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__circeKeyCodec__Lframework_utils_CirceKeyCodec($m_Lapp_prelude_AppCurrency$namedEnum$());
    this.aXO = true;
  }
  return this.aXN;
});
$p.aC = (function() {
  if ((!this.aXM)) {
    this.aXL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_CirceCodecExts$package$().W1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Codec$(), this.Au(), this.Au());
    this.aXM = true;
  }
  return this.aXL;
});
$p.bNp = (function() {
  if ((!this.aXS)) {
    this.aXR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__schema__Lsttp_tapir_Schema($m_Lapp_prelude_AppCurrency$namedEnum$()).bw("A currency code");
    this.aXS = true;
  }
  return this.aXR;
});
$p.dl = (function(x) {
  return x.aih;
});
var $d_Lapp_prelude_AppCurrency$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_prelude_AppCurrency$, "app.prelude.AppCurrency$", ({
  Ia: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_prelude_AppCurrency$ as $d_Lapp_prelude_AppCurrency$ };
var $n_Lapp_prelude_AppCurrency$;
function $m_Lapp_prelude_AppCurrency$() {
  if ((!$n_Lapp_prelude_AppCurrency$)) {
    $n_Lapp_prelude_AppCurrency$ = new $c_Lapp_prelude_AppCurrency$();
  }
  return $n_Lapp_prelude_AppCurrency$;
}
export { $m_Lapp_prelude_AppCurrency$ as $m_Lapp_prelude_AppCurrency$ };
/** @constructor */
function $c_Lapp_prelude_AppCurrency() {
}
export { $c_Lapp_prelude_AppCurrency as $c_Lapp_prelude_AppCurrency };
$p = $c_Lapp_prelude_AppCurrency.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_prelude_AppCurrency;
/** @constructor */
function $h_Lapp_prelude_AppCurrency() {
}
export { $h_Lapp_prelude_AppCurrency as $h_Lapp_prelude_AppCurrency };
$h_Lapp_prelude_AppCurrency.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.av0 = (function() {
  var x = $s_Lapp_prelude_AppCurrency$__USD__Lapp_prelude_AppCurrency();
  if (((x !== null) && (x === this))) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsquants_market_USD$();
  }
  var x$3 = $s_Lapp_prelude_AppCurrency$__EUR__Lapp_prelude_AppCurrency();
  if (((x$3 !== null) && (x$3 === this))) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsquants_market_EUR$();
  }
  var x$5 = $s_Lapp_prelude_AppCurrency$__GBP__Lapp_prelude_AppCurrency();
  if (((x$5 !== null) && (x$5 === this))) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsquants_market_GBP$();
  }
  var x$7 = $s_Lapp_prelude_AppCurrency$__INR__Lapp_prelude_AppCurrency();
  if (((x$7 !== null) && (x$7 === this))) {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsquants_market_INR$();
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
function $isArrayOf_Lapp_prelude_AppCurrency(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fW)));
}
export { $isArrayOf_Lapp_prelude_AppCurrency as $isArrayOf_Lapp_prelude_AppCurrency };
var $d_Lapp_prelude_AppCurrency = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "app.prelude.AppCurrency", ({
  fW: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_prelude_AppCurrency as $d_Lapp_prelude_AppCurrency };
/** @constructor */
function $c_Lapp_prelude_AppCurrency$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.aig = null;
  this.aih = 0;
  this.aig = \u03b4name$2;
  this.aih = _$ordinal$2;
}
export { $c_Lapp_prelude_AppCurrency$$anon$1 as $c_Lapp_prelude_AppCurrency$$anon$1 };
$p = $c_Lapp_prelude_AppCurrency$$anon$1.prototype = new $h_Lapp_prelude_AppCurrency();
$p.constructor = $c_Lapp_prelude_AppCurrency$$anon$1;
/** @constructor */
function $h_Lapp_prelude_AppCurrency$$anon$1() {
}
export { $h_Lapp_prelude_AppCurrency$$anon$1 as $h_Lapp_prelude_AppCurrency$$anon$1 };
$h_Lapp_prelude_AppCurrency$$anon$1.prototype = $p;
$p.s = (function() {
  return 0;
});
$p.e = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.u = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.t = (function() {
  return this.aig;
});
$p.n = (function() {
  return this.aig;
});
$p.co = (function() {
  return this.aih;
});
$p.U = (function(p) {
  return this;
});
var $d_Lapp_prelude_AppCurrency$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_prelude_AppCurrency$$anon$1, "app.prelude.AppCurrency$$anon$1", ({
  Ib: 1,
  fW: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  r: 1,
  d: 1,
  e: 1,
  k: 1
}));
export { $d_Lapp_prelude_AppCurrency$$anon$1 as $d_Lapp_prelude_AppCurrency$$anon$1 };
var $t_Lapp_prelude_AppCurrency$__USD = null;
function $u_Lapp_prelude_AppCurrency$__USD(x) {
  $t_Lapp_prelude_AppCurrency$__USD = x;
}
export { $t_Lapp_prelude_AppCurrency$__USD as $t_Lapp_prelude_AppCurrency$__USD, $u_Lapp_prelude_AppCurrency$__USD as $u_Lapp_prelude_AppCurrency$__USD };
var $t_Lapp_prelude_AppCurrency$__EUR = null;
function $u_Lapp_prelude_AppCurrency$__EUR(x) {
  $t_Lapp_prelude_AppCurrency$__EUR = x;
}
export { $t_Lapp_prelude_AppCurrency$__EUR as $t_Lapp_prelude_AppCurrency$__EUR, $u_Lapp_prelude_AppCurrency$__EUR as $u_Lapp_prelude_AppCurrency$__EUR };
var $t_Lapp_prelude_AppCurrency$__GBP = null;
function $u_Lapp_prelude_AppCurrency$__GBP(x) {
  $t_Lapp_prelude_AppCurrency$__GBP = x;
}
export { $t_Lapp_prelude_AppCurrency$__GBP as $t_Lapp_prelude_AppCurrency$__GBP, $u_Lapp_prelude_AppCurrency$__GBP as $u_Lapp_prelude_AppCurrency$__GBP };
var $t_Lapp_prelude_AppCurrency$__INR = null;
function $u_Lapp_prelude_AppCurrency$__INR(x) {
  $t_Lapp_prelude_AppCurrency$__INR = x;
}
export { $t_Lapp_prelude_AppCurrency$__INR as $t_Lapp_prelude_AppCurrency$__INR, $u_Lapp_prelude_AppCurrency$__INR as $u_Lapp_prelude_AppCurrency$__INR };
//# sourceMappingURL=app.prelude.-App-Currency.js.map
